import { CHARTS_STORE_NAME, IStore } from './store';
import { useDispatch, useSelector } from 'react-redux';
import { LocationType, useFrontendLocationSelector, useFrontendSubscriptionStatus } from '@cmctechnology/webinvest-store-frontend';
import { useEffect, useState } from 'react';
import { ISparkChartRequest } from './charts/spark/models';
import { subscribeSparkCharts, unsubscribeSparkCharts } from './SparkChartActions';
import { IChartSummary } from './charts/simple/models';
import { API_NAMES } from './SparkChartActions';
import { SparkChartUtils } from './charts/spark/utils';

export const useSparkChartStatsSelector = (location: LocationType) => {
  const feLocation = <string>useFrontendLocationSelector(location, CHARTS_STORE_NAME, API_NAMES.ChartDataSparkGet1);
  return useSelector((store: IStore) => (store.charts?.[feLocation] as IChartSummary)?.stats);
};

export const useSparkCharts = (location: LocationType, request: ISparkChartRequest) => {
  const key = SparkChartUtils.getChartKeyFromRequest(request);
  const charts = useSelector((store: IStore) => store.charts[key]);
  const dispatch = useDispatch();
  const { polling, error, fetching } = useFrontendSubscriptionStatus(CHARTS_STORE_NAME, API_NAMES.ChartDataSparkGet1, key);
  const [prevRequest, setPrevRequest] = useState(request);

  useEffect(() => {
    dispatch<any>(subscribeSparkCharts(location, request));

    return () => {
      dispatch<any>(unsubscribeSparkCharts(location, request));
    };
  }, []);

  useEffect(() => {
    if (request.instrumentCode !== prevRequest.instrumentCode) {
      dispatch<any>(subscribeSparkCharts(location, request));
      dispatch<any>(unsubscribeSparkCharts(location, prevRequest));
      setPrevRequest(request);
    }
  }, [request.instrumentCode]);

  return {
    loading: fetching && !charts,
    polling,
    error,
    data: charts,
    fetching
  };
};
